/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitResultResponse
 */
export interface SubmitResultResponse {
    /**
     * 
     * @type {string}
     * @memberof SubmitResultResponse
     */
    message: string;
}

/**
 * Check if a given object implements the SubmitResultResponse interface.
 */
export function instanceOfSubmitResultResponse(value: object): value is SubmitResultResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SubmitResultResponseFromJSON(json: any): SubmitResultResponse {
    return SubmitResultResponseFromJSONTyped(json, false);
}

export function SubmitResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function SubmitResultResponseToJSON(json: any): SubmitResultResponse {
    return SubmitResultResponseToJSONTyped(json, false);
}

export function SubmitResultResponseToJSONTyped(value?: SubmitResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

